module.exports = __webpack_public_path__ + "static/img/home_service_images_39_h5_zh.a14dd82.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_service_images_39_h5_zh.png
// module id = rL0K
// module chunks = 34